import React, { HTMLAttributes } from 'react'

import CardHeading from '@/components/typography/CardHeading'
import { cn } from '@/lib/utils'

type Props = HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
}

const SectionHeading: React.FC<Props> = ({ children, className, ...props }) => (
  <CardHeading className={cn('my-2', className)} {...props}>
    {children}
  </CardHeading>
)

export default SectionHeading
